import {
  HTTP_COUNTRY_FETCHING,
  HTTP_COUNTRY_SUCCESS,
  HTTP_COUNTRY_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_COUNTRY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case HTTP_COUNTRY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_COUNTRY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    default:
      return state;
  }
};
